import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => (
  <footer className="site-footer">
    <div className="footer-grid">
      <div className="footer-brand">
        <Link to="/" className="footer-logo">
          <span className="brand-mark">
            <i />
            <b />
          </span>
          Observer Theory
        </Link>
        <p>
          The public accountability record for manifestation and law of
          attraction coaches, law of assumption teachers, tarot readers,
          psychics, mediums, astrologers, energy practitioners, and spiritual
          teachers.
        </p>
        <p className="footer-disclaimer">
          Profiles and reviews are informational. Observer Theory does not
          provide medical, legal, financial, or crisis advice and does not
          guarantee outcomes.
        </p>
      </div>
      <div>
        <h3>Explore</h3>
        <Link to="/practitioners">Browse all practitioners</Link>
        <Link to="/practitioners/manifestation-coaches">
          Manifestation coaches
        </Link>
        <Link to="/practitioners/tarot-readers">Tarot readers</Link>
        <Link to="/search">Search practitioners</Link>
        <Link to="/write-review">Write a review</Link>
        <Link to="/nominate">Nominate a practitioner</Link>
        <Link to="/for-reviewers">For reviewers</Link>
      </div>
      <div>
        <h3>Trust</h3>
        <Link to="/trust/reviews">Evidence classes</Link>
        <Link to="/trust/disputes">Disputes</Link>
        <Link to="/trust/ranking">Ranking explanation</Link>
        <Link to="/trust/seeding">Opening profile methodology</Link>
        <Link to="/trust/methodology">Publication methodology</Link>
        <Link to="/trust/independence">Independence boundaries</Link>
      </div>
      <div>
        <h3>Practitioners</h3>
        <Link to="/practitioners/psychics-intuitives">
          Psychics and intuitives
        </Link>
        <Link to="/practitioners/mediums-mediumship">Mediums</Link>
        <Link to="/practitioners/astrologers">Astrologers</Link>
        <Link to="/search">Find your profile</Link>
        <Link to="/for-practitioners">For practitioners</Link>
        <Link to="/report?kind=self">Submit your practice</Link>
        <Link to="/report?kind=correction">Suggest a correction</Link>
        <Link to="/support">Support</Link>
        <Link to="/pricing">Membership</Link>
      </div>
      <div>
        <h3>Company</h3>
        <Link to="/about">About</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/safety">Safety</Link>
        <Link to="/account-deletion">Delete account</Link>
      </div>
    </div>
    <div className="footer-bottom">
      <span>
        © {new Date().getFullYear()} Observer Theory · Operated by Joseph Alai
      </span>
      <span>Research for better spiritual discernment.</span>
    </div>
  </footer>
);

export default Footer;
